import React from "react";
import "../CreateFlightPlan.css";
import { Button, CircularProgress } from "@mui/material";
import ROUTE_PATHS from "../../../../../utils/routePaths";
import { Link } from "react-router-dom";
import CommercialAirlineNavigationBar from "../../../../../components/element/CommercialAirlineNavigationBar";

const CreateFlightPlanHeader = ({
  isValid,
  onClickBack,
  onClickSave,
  isLoading,
}) => {
  return (
    <div>
      <CommercialAirlineNavigationBar showHeaderBar={false}/>
      <header className="create-flight-plan-header">
        <div className="create-flight-plan-header-bar-container">
          <div className="create-flight-plan-header-bar">
            <div className="create-flight-plan-left">
              <div className="navigation-header">
                <Link
                  to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
                  className="navigation-header-link"
                >
                  Home/
                </Link>
                <Link
                  to={ROUTE_PATHS.COMMERCIAL_AIRLINE_FLIGHT_ROSTER}
                  className="navigation-header-link"
                >
                  Flight Roster/
                </Link>
                Create Flight Plan
              </div>
            </div>
            <p className="create-flight-plan-center">Flight Plan Details </p>
            <div className="create-flight-plan-right">
              <Button
                variant="contained"
                className="cancel"
                onClick={onClickBack}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={isValid ? onClickSave : null}
                disabled={!isValid}
              >
                {isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default CreateFlightPlanHeader;
